import {
    sourceUpdateModel,
    sourceUpdateImage,
    sourceRenderedListingTestLink,
    sourceRenderedListingDiscoverRequest,
} from "../../../actions/source-actions"

import buildItemConnector from "../../common/build-item-connector"

export default buildItemConnector(
    "sources",
    false,
    sourceUpdateModel,
    sourceUpdateImage,
    {},
    // dashboard-api's check of a Rendered listing source's settings, the link being tested against its pattern, and
    // the page dashboard-api looked at to set them up
    ({
        renderedListingCheck,
        isCheckingRenderedListing,
        renderedListingCheckFailed,
        renderedListingTestLink,
        renderedListingDiscover,
        isDiscoveringRenderedListing,
        renderedListingDiscoverError,
    }) => ({
        renderedListingCheck,
        isCheckingRenderedListing,
        renderedListingCheckFailed,
        renderedListingTestLink,
        renderedListingDiscover,
        isDiscoveringRenderedListing,
        renderedListingDiscoverError,
    }),
    (dispatch) => ({
        onTestLinkChange: (testLink) =>
            dispatch(sourceRenderedListingTestLink(testLink)),
        onDiscover: (url) =>
            dispatch(sourceRenderedListingDiscoverRequest(url)),
    })
)
